import {Action} from "../actions/storeForAccountActions";
import {ActionType} from '../actionTypes';
import {ErrorDto, SuccessDto} from "../../dtos";

export interface StoreForAccountInt {
    file: null | File;
    type: null | string;
    loading: boolean;
    error: ErrorDto | null;
    successInfo?: SuccessDto | null;
}

const initialState = {
    file: null,
    type: null,
    loading: false,
    error: null,
    successInfo: null
}

export const storeForAccountReducer = (state: StoreForAccountInt = initialState, action: Action) => {
    switch (action.type) {
        case ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_START:
        case ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_START:
        case ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_START:
        {
            return {...state, type: action.type, loading: true, error: null, successInfo: null}
        }
        case ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_SUCCESS:
        case ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_SUCCESS:
        case ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_SUCCESS:
        {
            return {...state, file: action.payload.file, type: action.type, successInfo: action.payload.successInfo}
        }
        case ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_COMPLETE:
        case ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_COMPLETE:
        case ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_COMPLETE:
        {
            return {...state, type: action.type, loading: false, error: null, successInfo: null}
        }
        case ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_ERROR:
        case ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_ERROR:
        case ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_ERROR:
        {
            return {...state, error: action.payload, type: action.type, loading: false, successInfo: null}
        }
        default: {
            return state
        }
    }
}